import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CssBaseline, Box } from '@mui/material';

// 컴포넌트 및 페이지 호출
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Join from './pages/user/Join';
import Login from './pages/user/Login';
import QuestionList from './pages/question/QuestionList';
import QuestionCreate from './pages/question/QuestionCreate';
import QuestionDetail from './pages/question/QuestionDetail';
import QuestionEdit from './pages/question/QuestionEdit';
import CategoryManage from './pages/category/CategoryManage';
import CategorySelect from './pages/category/CategorySelect';
import StudyPlayer from './pages/study/StudyPlayer';
import Dashboard from './pages/dashboard/UserDashboard.jsx';
import CommonCodeManage from './pages/commoncode/CommonCodeManage';
// 비디오 관리 페이지 추가
import VideoManage from './pages/video/VideoManage'; 
import StudyResult from './pages/study/StudyResult';
import UserManage from './pages/admin/UserManage';
import UserGroupManage from './pages/admin/GroupManage.jsx';

function App() {
  // 로그인 여부 확인
  const isAuthenticated = !!localStorage.getItem('token');

  return (
    <Router>
      <CssBaseline />
      {/* Flex 레이아웃을 적용하여 컨텐츠가 적어도 푸터가 바닥에 붙도록 설정합니다.
        minHeight: '100vh'는 화면 전체 높이를 사용하겠다는 뜻입니다.
      */}
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        
        {/* component="main"으로 지정하고 flex: 1을 주면, 
          남은 공간을 이 Box가 다 차지하여 Footer를 아래로 밀어냅니다.
        */}
        <Box component="main" sx={{ p: 3, flex: 1 }}>
          <Routes>
            <Route 
              path="/" 
              element={
                isAuthenticated ? (
                  <Navigate replace to="/category-select" />
                ) : (
                  <Navigate replace to="/login" />
                )
              } 
            />
            
            <Route path="/list" element={<QuestionList />} />
            <Route path="/create" element={<QuestionCreate />} />
            <Route path="/questions/:id" element={<QuestionDetail />} />
            <Route path="/edit/:id" element={<QuestionEdit />} />
            
            {/* 회원가입 버튼 사용 안함_202602 */}
            {/* <Route path="/join" element={<Join />} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/category" element={<CategoryManage />} />

            <Route path="/video" element={<VideoManage />} />

            <Route path="/category-select" element={<CategorySelect />} />
            <Route path="/study/:categoryId" element={<StudyPlayer />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/study-result" element={<StudyResult />} />

            <Route path="/common-code" element={<CommonCodeManage />} />

            <Route path="/admin/users" element={<UserManage />} />
            <Route path="/admin/groups" element={<UserGroupManage />} />
            
            <Route path="*" element={<Box sx={{ p: 5, textAlign: 'center' }}>페이지를 찾을 수 없습니다.</Box>} />
          </Routes>
        </Box>

        {/* 푸터 컴포넌트 호출 - 모든 라우트 하단에 공통으로 표시됩니다. */}
        <Footer />
      </Box>
    </Router>
  );
}

export default App;